import { useQuery } from '@tanstack/react-query';

import { ActivtyLog, ActivityLogFilters } from '../../models/activty-log.model';

import API from '../../services/api';

import activityLogKeys from '../activity-logs/_queryKeys';

const getActivityLogs = async (
    filters: ActivityLogFilters,
): Promise<ActivtyLog[]> => {
    const { data } = await API.getActivityLogs(filters);
    return data;
};

export default function useActivityLogsQuery(filters: ActivityLogFilters) {
    return useQuery({
        queryKey: activityLogKeys.getActivityLogs(
            filters.target_model,
            filters.target_id,
        ),
        queryFn: () => getActivityLogs(filters),
        enabled: Boolean(filters.target_model && filters.target_id),
    });
}
